import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-invoices-filter-modal',
    templateUrl: './invoicesFilters-modal.html',
    standalone: false
})
export class InvoicesFilterModalComponent {

  product: string;

  constructor(
    public dialogRef: MatDialogRef<InvoicesFilterModalComponent>, @Inject(MAT_DIALOG_DATA) data: any) {
    if (data && data.product) {
      this.product = data.product;
    }
  }

}
